import React from 'react';
import Header from 'pages/home/Header';
import NewsCard from 'pages/news-room/NewsCard';
import { Container, Wrapper, NewsCards, Title } from 'styles/pages/news-room';

const NewsRoom = () => {
  return (
    <Container>
      <Header showNavMenu={false} />
      <Wrapper>
        <Title>Updates and Press Releases</Title>
        <NewsCards>
          <NewsCard />
        </NewsCards>
      </Wrapper>
    </Container>
  );
};

export default NewsRoom;
